import * as React from "react"
import Button from "../button"
import '../cookie.scss'

/**
 * @param {{
 *   pageData: import('../../data/page').Page,
 *   globalData: import('../../data/global').Global,
 * }} param0
 */
const Cookie = ({ isOpen, closeModal }) => {
	const handleAcceptCookies = () => {
		// Get the browsing history and store it in a cookie, max-age is the second
		const history = JSON.stringify(window.history);
		document.cookie = "browsing_history=" + history + "; max-age=86400; path=/";
		closeModal(false);
	}

	const closePopUp = () => {
		closeModal(false);
	}

	return (
		<>{isOpen ? (
			<div className="flex cookie-box">
				<div className="flex cookie-content relative lg:w-[90%] md:w-[80%] sm:w-[80%] w-[90%] sm:ml-[20px] ml-[20px] sm:flex-nowrap flex-wrap">
					<h1 className="cookie-text md:p-5 sm:p-4 p-2 2xl:text-[16px] xl:text-[14px] lg:text-[14px] md:text-[14px] sm:text-[14px] text-[14px] md:w-[60%] 2xl:w-[70%] xl:w-[90%] lg:w-[90%] ">Our website uses cookies to make your browsing experience better. By using our site you agree to our use of cookies.</h1>
					<div className="accept-all-cookie 2xl:w-[15%] xl:w-[20%] lg:w-[24%] md:w-[26%] sm:w-[28%] w-[36%] md:p-5 sm:p-4 p-2 justify-center text-center">
						<Button onClick={handleAcceptCookies} className="xl:text-[15px] lg:text-[14px] md:text-[12px] sm:text-[12px] text-[12px]">Ok</Button>
					</div>
					<div className="cross-btn 2xl:w-[15%] xl:w-[20%] lg:w-[24%] md:w-[26%] sm:w-[28%] w-[36%] md:p-5 sm:p-4 p-2 justify-center text-center">
						<Button onClick={closePopUp} className="xl:text-[15px] lg:text-[14px] md:text-[12px] sm:text-[12px] text-[12px]">Decline</Button>
					</div>
				</div>
			</div>
		) : null}
		</>
	)
}

export default Cookie
